module.exports = __webpack_public_path__ + "img/BlinkArt_Sword12_Green.c4110489.png";